import { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import cx from 'classnames';
import { longDate, longWeekDay } from '../../utils/dateFormat';
import { useStore } from '../../hooks/store';
import Price from "../../utils/prices";
import Ticket from "../../utils/tickets";

import {
  Row, Col2, Name, Name2, SmallDesc, CounterBtn, Number, Action, Subtotal, Button, EmptyMessage, RemoveItem
} from '../../styles/styles.js';

const TicketsSelection = ({theme}) => {
  const [state, dispatch] = useStore();
  const { tickets, totalPrice, totalPeople, deliveryPrice, selectedDate, selectedDateTime, selectedTime, dateContext,
    section, clientState, eventDates, fares, quantityLimit, parkingMaxed, totalAdults,
    hidePackageAddons, dateTimeConfirmed, availMaxed, step, stepped, giftAddon, giftAddonName } = state;
  const [buttonMessage, setButtonMessage] = useState('');

  useEffect(() => {
    // console.log('dateTimeConfirmed', dateTimeConfirmed);
    const message = (section === 'gift-tickets') || dateTimeConfirmed ? '' : 'Please select a date and time.';
    setButtonMessage(message);
  }, [section, dateTimeConfirmed]);

  const handleDateTimeChange = () => {
    dispatch('SET', {
      confirmTimeChange: true
    });
  }
  const addTicket = (slug) => {
    // console.log('TicketsSelection addTicket');
    dispatch('ADD_TICKET', slug);
    dispatch('RESET_MESSAGES');
  }
  const subtractTicket = (slug) => {
    dispatch('SUBTRACT_TICKET', slug);
    dispatch('RESET_MESSAGES');
  }
  const removeTickets = (slug) => {
    if (_.includes(slug, 'wallet'))
      dispatch('SET', {
        isPostage: false,
        giftAddon: null,
        giftAddonName: null
      });
    dispatch('REMOVE_TICKETS', slug);
    dispatch('RESET_MESSAGES');
  }

  const renderGiftAddons = () => {
    if (giftAddon) {
      // console.log('giftAddon', giftAddon);
      const giftType = _.includes(giftAddon, 'christmas') ? 'christmas' : _.includes(giftAddon, 'wallet') ? 'wallet' : 'box';
      // console.log('giftType', giftType);
      // const notWinter = _.includes(t.slug, giftType) && !_.includes(t.slug, 'christmas');
      const gift = _.find(tickets, t => t.slug === giftAddon);
      // console.log('gift', gift);
      const giftPrice = gift.price;
      const giftName = gift.name;
      return (
        <Row>
          <Col2 className="col-7 pl-0 stacked">
            <Name2 className="bold">{giftName}</Name2>
          </Col2>
          <Col2 className="col-2 px-0"></Col2>
          <Col2 className="col-3 pr-0 right-align stacked"><Subtotal>
            &pound;{giftPrice}
            <RemoveItem className={cx({'dark': theme === 'dark'})} onClick={() => removeTickets(giftAddon)}>Remove</RemoveItem>
          </Subtotal></Col2>
        </Row>
      );
    }
    return null;
  }

  const ticketRows = () => {
    const qty = [
      ...clientState.tq,
      ...clientState.iq || []
    ];
    const rows = qty.filter(item => {
      return item.quantity > 0 && item.id !== 'gift_box' && item.id !== 'winter_box' && item.id !== 'wallet';
    });
    if (rows.length > 0) {
      // console.log('FARES', fares);
      return rows.map(row => {
        const qty = row.quantity;
        let tix = fares.find(o => o.id === row.id);
        let addDisabled = false, subtractDisabled = true;
        if (tix) {
          if (section !== 'gift-tickets') {
            if (row.id.includes('family') || row.id.includes('adult') || row.id.includes('child')) {
              if (quantityLimit === totalPeople) addDisabled = true;
              if (availMaxed) addDisabled = true;
            }
            // if (row.id.includes('package') && hidePackageAddons) addDisabled = true;
            if (row.id === 'parking' && parkingMaxed) addDisabled = true;
          }
          if (qty > 0) subtractDisabled = false;
          const p = parseFloat(tix.price);
          const subTotalPrice = p * qty;

          return (
            <Row>
              <Col2 className="col-5 pl-0 stacked">
                <Name2 className="bold">{tix.summaryLabel}</Name2>
                {tix.labelDescription && <SmallDesc className={cx('left', {'dark': theme === 'dark'})}>{tix.labelDescription}</SmallDesc>}
              </Col2>
              <Col2 className="counter col-4 px-0">
                <CounterBtn type="button" disabled={subtractDisabled} className={cx({'dark': theme === 'dark', 'disabled': subtractDisabled})}
                            onClick={() => subtractTicket(tix.id)}>
                  -
                </CounterBtn>
                <Number className={cx({'dark': theme === 'dark'})}>{qty}</Number>
                <CounterBtn type="button" disabled={addDisabled} className={cx({'dark': theme === 'dark', 'disabled': addDisabled })}
                            onClick={() => addTicket(tix.id)}>
                  +
                </CounterBtn>
              </Col2>
              <Col2 className="col-3 pr-0 right-align stacked"><Subtotal>
                &pound;{subTotalPrice.toFixed(2)}
                <RemoveItem className={cx({'dark': theme === 'dark'})}
                            onClick={() => removeTickets(tix.id)}>Remove</RemoveItem>
              </Subtotal></Col2>
            </Row>
          );
        }
      });
    }
    return <EmptyMessage>Your basket is empty.</EmptyMessage>;
  }

  return (
    <Fragment>
      {ticketRows()}
      {renderGiftAddons()}
      {dateTimeConfirmed && section !== 'gift-tickets' && <Fragment>
        <hr/>
        <Row className="with-label nobottom">
          <Name2 className="bold">Date:</Name2> &nbsp; <Name2>{longWeekDay(selectedDateTime)}, <span className="nowrap">{longDate(selectedDateTime)}</span></Name2>
        </Row>
        <Row className="with-label">
          <Name2 className="bold">Time:</Name2> &nbsp; <Name2>{selectedTime}</Name2>
        </Row>
        {theme !== 'dark' && <Row>
          <SmallDesc className="left link bold" onClick={handleDateTimeChange}>Change date & time <i className="fa fa-chevron-right"></i></SmallDesc>
        </Row>}
      </Fragment>}
      <hr/>
      {stepped >= 3 && deliveryPrice !== null && <Row className="padtop">
        <Col2 className="col-8 pl-0 left-align"><Name2 className="bold">Shipping:</Name2></Col2>
        <Col2 className="col-4 pr-0 right-align"><Name>&pound;{deliveryPrice}</Name></Col2>
      </Row>}
      <Row className="padtop">
        <Col2 className="col-8 pl-0 left-align"><Name>Total:</Name></Col2>
        <Col2 className="col-4 pr-0 right-align"><Name>&pound;{totalPrice.toFixed(2)}</Name></Col2>
      </Row>
      {buttonMessage !== '' && <EmptyMessage>{buttonMessage}</EmptyMessage>}
    </Fragment>
  );
}

export default TicketsSelection;
